import * as React from 'react';
import { IconCar16, UIText1 } from '@cian/ui-kit';

import * as styles from './highway.css';

export const Highway = ({ name }: { name: string }) => {
  return (
    <div className={styles['highway']}>
      <div className={styles['icon']}>
        <IconCar16 color="gray60_100" />
      </div>
      <UIText1 color="black_100">{name}</UIText1>
    </div>
  );
};
